import type { ComponentRef, ElementRef, InputSignal, ViewContainerRef } from '@angular/core';
import { InjectionToken } from '@angular/core';

export type RtButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'outline'
  | 'outline-rounded'
  | 'plain'
  | 'informative'
  | 'success'
  | 'error'
  | 'warning'
  | 'tellent'
  | 'kiwihr';

export type RtButtonColorContextVariant = 'outline-ghost' | 'plain-ghost' | 'plain-onoverlay';

export type RtPlanButtonVariant = 'launch' | 'scale' | 'lead' | 'start' | 'grow' | 'optimize';

export type RtInfoboxButtonVariant =
  | 'outline-informative'
  | 'outline-success'
  | 'outline-warning'
  | 'outline-error';

export type RtAddNewButtonVariant = 'rounded' | 'wide' | 'default';

export type RtIconButtonVariant = 'transparent-light' | 'transparent-dark';

export type RtWalkthroughButtonVariant = 'walkthrough-trigger';

export const setInputs = <
  T extends ComponentRef<any>,
  U extends {
    [k in keyof T['instance']]: T['instance'][k] extends InputSignal<infer R>
      ? R
      : T['instance'][k];
  },
>(
  componentRef: T,
  props: Partial<U>,
) => {
  const { changeDetectorRef } = componentRef;
  Object.entries(props).forEach(([prop, value]) => componentRef.setInput(prop, value));
  changeDetectorRef.detectChanges();
};

export abstract class ExtendableButton {
  public prefix: ViewContainerRef;
  public suffix: ViewContainerRef;
  public elRef: ElementRef;
}

export const ExtendableButtonToken = new InjectionToken<ExtendableButton>('ExtendableButton');
export type RtButtonSize = 'small-x' | 'small' | 'medium';
